import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { WINDOW_PROVIDERS } from '../shared-providers/window.providers';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { AppMaterialModule } from '../app-material.module';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { LockerCancellationDialogModule } from '../locker-cancellation-dialog/locker-cancellation-dialog.module';
import { CustomPolicyComponent } from './components/custom-policy/custom-policy.component';

@NgModule({
    declarations: [
        CustomPolicyComponent,
        FooterComponent,
        HeaderComponent
    ],
    imports: [
        FlexLayoutModule,
        CommonModule,
        AppMaterialModule,
        SharedComponentsModule,
        LockerCancellationDialogModule
    ],
    exports: [
        CustomPolicyComponent,
        FooterComponent,
        HeaderComponent
    ],
    providers: [WINDOW_PROVIDERS]
})
export class MarginalsModule {
}
